import React from "react";
import cx from "classnames";
import { dashboardContent } from ".";
import { printableMain } from "../../utils/print";
import { DashboardReadonlyHeader } from "./component/Header/ReadonlyHeader";
import Button from "@ui/Button";
import { ArrowRightUpLine } from "@ui/IconV2/react";
import { css } from "@linaria/core";
import { spacings } from "@ui/Theme";
import t from "../../../../../i18n";
import { useTranslations } from "../../../../../api/useTranslations";
import { toPath } from "../../../../../router/helpers/path";
import { toBasenamePath } from "../../../../../router/helpers/navigation";
import { DashboardContent } from "./component/Content";

export function DashboardLite({
  projectId,
  dashboardId,
  powerUnitId,
  withHeader = true,
  className,
}: {
  projectId: string;
  dashboardId: string;
  powerUnitId?: string | null;
  withHeader?: boolean;
  className?: string;
}) {
  const translations = useTranslations();

  return (
    <main className={cx(dashboardContent, className, printableMain)}>
      {dashboardId && (
        <>
          {withHeader && (
            <div className={dashboardReadonlyHeaderwrapper}>
              <DashboardReadonlyHeader
                projectId={projectId}
                dashboardId={dashboardId}
                enableScrollAnimation={false}
              />
              {dashboardId !== undefined && (
                <Button
                  variant="primary"
                  leftIcon={<ArrowRightUpLine />}
                  onClick={() =>
                    window.open(
                      toBasenamePath(
                        toPath("/projects/:projectId/dashboards/:dashboardId", {
                          projectId,
                          dashboardId: dashboardId!,
                        }),
                      ),
                    )
                  }
                >
                  {t("project.dashboard.lite.header.button", translations)}
                </Button>
              )}
            </div>
          )}
          <DashboardContent
            powerUnitId={powerUnitId}
            projectId={projectId}
            dashboardId={dashboardId}
          />
        </>
      )}
    </main>
  );
}

//#region CSS
const dashboardReadonlyHeaderwrapper = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  grid-column: 1 / span 3;
  padding: 0 ${spacings.xl};

  padding-top: ${spacings.l};

  & > :nth-child(1) {
    padding: 0;
  }
`;

export default DashboardLite;

// const overrideDashboardContent = css`
//   grid-template-columns: 48px 1fr 48px;
// `;
//#endregion
